import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const PadresPTApi = () => {
    const [cargando, setCargando] = useState(false);

    const getPadresProductoTerminado = async (params) => {
        try {
            setCargando(true);
            const response = await api.get("padres_producto_terminado", params);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const crearPadreProductoTerminado = async (data) => {
        try {
            setCargando(true);
            const response = await api.post("padres_producto_terminado", data);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const deletePadreProductoTerminado = async (id) => {
        try {
            setCargando(true);
            const response = await api.eliminar(
                `padres_producto_terminado/${id}`,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const actualizarPadreProductoTerminado = async (id, data) => {
        try {
            setCargando(true);

            const response = await api.put(
                `padres_producto_terminado/${id}`,
                data,
            );
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPadresProductoTerminado,
        crearPadreProductoTerminado,
        deletePadreProductoTerminado,
        actualizarPadreProductoTerminado,

        cargando,
    };
};
